import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { httpRequestInterceptor } from './interceptors/http-request.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		provideAnimationsAsync(),
		provideHttpClient(withInterceptors([httpRequestInterceptor])),
		provideCharts(withDefaultRegisterables()),
		provideAnimations(),
		provideToastr({
			timeOut: 10000,
			positionClass: 'toast-bottom-center',
			preventDuplicates: true
		})
	]
};
